import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import ReactToPrint from 'react-to-print';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
const headCells = [

	 { id: 'cs_date', numeric: false, label: 'Date' }, 
  { id: 'or_name', numeric: false, label: 'Name' },
  { id: 'or_email', numeric: false, label: 'Email Id' },
  { id: 'or_phone', numeric: false, label: 'Phone No.' },  
  { id: 'sb_title', numeric: false, label: 'Subscription' },  
  { id: 'sm_slotname', numeric: false, label: 'Slot' },  
  { id: 'cs_classattended', numeric: false, label: 'Status' },  
  
  
 
 ]

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});




export default class ClientAttendreport extends Component {
	
    constructor(props) {
    super(props);
      const now = dayjs();
const startOfMonth = now.startOf('month');
const today = now;
     this.state = {
		 
		 
		 ExportData:[],id:'',or_name:'',cu_billingaddress:'',subscribeslotData:[],smid:'',
	 
	  search:'',isactive:'',searchactive:'',sbtitle:'',
		       
		 redirect: false,editredirect: false,no_id:'',no_date:'',exportdata:[],
     CustomerData:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],rolelabel:'Select Staff',subscribeData:[],classtype:3,cs_classattended:'',
	 
	  order:'desc' ,orderBy:'',
	  fromdate: startOfMonth,
  fromdate1: startOfMonth.format('YYYY-MM-DD'),
  todate: today,
  todate1: today.format('YYYY-MM-DD'),
	          
      }
	  this.updateDonenewParent = this.updateDonenewParent;
	}
	  

handleChangePage = (event, newPage) => {  

  
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   
  
  	 myChangeHandler = (event) => {
	
	 
  let nam = event.target.name;
  let val = event.target.value;  
 

  this.setState({[nam]: val});
  
}


   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };  

componentWillMount  () {
	

	document.title = "AthaYog Living - Report";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }

	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  this.onloadsubscribeBind();
  this.filterSlots();
  
}
 
onloadsubscribeBind() {
  axios.post(Serverurl+'ajaxsubscription.php?action=getall&sb_type='+this.state.classtype)
    .then(resp => {
      if (resp.data.length > 0) {
        let atrsubscribe = resp.data;

        // Filter the data here, if needed
        const filteredData = atrsubscribe.filter(item => item.sb_id !== "11" && item.sb_id !== "12" && item.sb_id !== "14" && item.sb_id !== "15");

        this.setState({ subscribeData: filteredData }, () => {
          const subscribeFromApi = this.state.subscribeData.map(row => ({
            value: row.sb_id,
            display: row.sb_title,
          }));
          this.setState({
            subscribeData: [{ value: '0', display: 'Select Subscription' }].concat(subscribeFromApi),
          });
        });
      } else {
        this.setState({ subscribeData: [] });
      }
    });
}


apicall(page,rowsPerPage){
	
 // axios.get(Serverurl+'ajaxreport.php?action=clientattend&or_name='+this.state.or_name+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&sb_id='+this.state.sbtitle+'&cs_classattended='+this.state.cs_classattended)
  
    axios.get(Serverurl+'ajaxreport.php?action=clientattend&or_name='+this.state.or_name+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&sb_id='+this.state.smid+'&startdate='+this.state.fromdate1+'&enddate='+this.state.todate1+'&cs_classattended='+this.state.cs_classattended)


  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  CustomerData:resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
		this.apiExportcall();
			
	 
     }
	 else{
		   this.setState({CustomerData:[],totaldata:0});
	 }
 
    });
}

apiExportcall(){
	
 axios.get(Serverurl+'ajaxreport.php?action=clientattend')

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  ExportData:resp.data,  
			   
			   

		    });
		
			
		
	 
     }
	 else{
		   this.setState({ExportData:[]});
	 }
 
    });
}

  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

handleClickSearch=()=>{   
   
  this.apicall(this.state.page,this.state.rowsPerPage); 
	
} 

handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ fromdate:dayjs(date),
fromdate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
todate: todate1,
todate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtodateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ todate:dayjs(date),
todate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
  
  filterSlots = () => {
	
  axios.post(Serverurl + 'ajaxslotmanagement.php?action=getall&sm_slottype='+this.state.classtype+'&sbid='+this.state.sbid+'&sm_bm_id='+localStorage.getItem("AYLbrid")+'&sorting=sm_order asc')
    .then(resp => {
      if ( resp.data.length > 0) {
        const formatted = resp.data.map(row => ({
          value: row.sm_id,
          display: row.sm_slotname,
         
        }));
        this.setState({
          subscribeslotData: [{ value: '', display: 'Select Slot' }, ...formatted]
        });
      } else {
        this.setState({ subscribeslotData: [] });
      }
    });
};

render() {
	
	
	if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return(
 
 
 <React.Fragment>
 
  <div className="mainheading"><h1>Customer Attendance Report</h1></div>

<div className="clear"></div>

	
	

 <div className="searchmaster">
 <ul>
 
  <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li> 
  
  {/*<li>
  <p>Select Subscription</p>
  <p>
    <FormControl className="stadrp">
      <Select
        className="txtbox"
        native
        value={this.state.sbtitle}
        onChange={this.myChangeHandler}
        name="sbtitle"
        fullWidth
      >
        {this.state.subscribeData.map((row) => (
          <option value={row.value} key={row.value}>
            {row.display}
          </option>
        ))}
      </Select>
    </FormControl>
  </p>
</li>
  
 <li><p>Name/Email/Phone</p>
 <p><TextField name="or_name" 
	   onChange={this.myChangeHandler} 
	   fullWidth 		 	 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   value={this.state.or_name}
                          /></p>
 
</li>*/}

<li><p>Select Slot</p>
 
 <Select
  className="txtbox"
  native
  value={this.state.smid}
  onChange={this.myChangeHandler}
  name="smid"
>
  {this.state.subscribeslotData.map((row, index) => (
    <option key={index} value={row.value}>
      {row.display}
    </option>
  ))}
</Select>
</li>
 
 <li>
  <p>Status</p>
  <p>
    <FormControl className="stadrp">
      <Select
        className="txtbox"
        native
        value={this.state.cs_classattended}
        onChange={this.myChangeHandler}
        name="cs_classattended"
        fullWidth
      >
        <option value="">Select Status</option>
        <option value="1">Present</option>
        <option value="0">Absent</option>
      </Select>
    </FormControl>
  </p>
</li>

				
					<li><p>&nbsp;</p><p >
		<ReactToPrint
						trigger={() => <p id="print-barcode" className="frmSecondarybtn"> PRINT </p>}
						content={() => this.componentRef}/>&nbsp;
		<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="Attendancereport"
							filename="Attendance Report"
							sheet="Attendance Report"
							buttonText="EXPORT"/>
							
			</p>		
		</li>		
		<li><p>
						
						<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>
				</p>		
		</li>
		
		
		</ul>
		
</div>	

		<div  ref={el => (this.componentRef = el)}  >	
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.CustomerData.length}
            />
                      <TableBody>
                     {stableSort(this.state.CustomerData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >

<TableCell>{this.formatDate(item.cs_date)}</TableCell>
<TableCell>{item.or_name}</TableCell>
<TableCell>{item.or_email}</TableCell>
<TableCell>{item.or_phone}</TableCell>

<TableCell>{item.sb_title}</TableCell>
<TableCell>{item.sm_slotname}</TableCell>
<TableCell>{item.cs_classattended}</TableCell>
	

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,50,100,150,200,250,300]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}    
      /> 
  </Paper>
    

</div>




<div style={{"display":"none"}}>
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="Attendancereport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.ExportData.length}
            />
                      <TableBody>
                     {stableSort(this.state.ExportData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >


<TableCell>{this.formatDate(item.cs_date)}</TableCell>
<TableCell>{item.or_name}</TableCell>
<TableCell>{item.or_email}</TableCell>
<TableCell>{item.or_phone}</TableCell>

<TableCell>{item.sb_title}</TableCell>
<TableCell>{item.sm_slotname}</TableCell>
<TableCell>{item.cs_classattended}</TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
 
  </Paper>
 
</div>


 </React.Fragment>
 



);


		}
	
}

